import AuditContainer from './AuditContainer'

export default function AuditScreen() {
    return <AuditContainer />
}
